"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliderCompanies = void 0;
/**
 * スタートアップ企業一覧スライダー
 */
require("swiper/css");
require("swiper/css/navigation");
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
swiper_1.Swiper.use([modules_1.Navigation, modules_1.Autoplay]);
const observerOptions = {
    root: null,
    rootMargin: "0px 0px",
    threshold: 0,
};
const observerSet = (callback, observerTarget) => {
    const observer = new IntersectionObserver(callback, observerOptions);
    observer.observe(observerTarget);
};
exports.sliderCompanies = (() => {
    return {
        configure: () => {
            const sliderTarget = document.getElementById("js-sliderCompanies");
            if (sliderTarget == null)
                return;
            observerSet(callback, sliderTarget);
            function callback(entries) {
                entries.forEach((entry) => {
                    var _a;
                    if (entry.intersectionRatio > observerOptions.threshold &&
                        !entry.target.classList.contains("is-visible")) {
                        if (entry.isIntersecting) {
                            const slidable = ((_a = sliderTarget.querySelectorAll(".swiper-slide")) === null || _a === void 0 ? void 0 : _a.length) >= 3;
                            /* eslint-disable @typescript-eslint/no-unused-vars */
                            const swiperOptions = {
                                centeredSlides: false,
                                slidesPerView: "auto",
                                spaceBetween: 24,
                                loop: slidable,
                                speed: 800,
                                autoplay: {
                                    delay: 4000,
                                    disableOnInteraction: false,
                                },
                                navigation: {
                                    nextEl: "#js-sliderCompanies__arrowNext",
                                    prevEl: "#js-sliderCompanies__arrowPrev",
                                },
                                loopAdditionalSlides: 1,
                            };
                            const swiper = new swiper_1.Swiper("#js-sliderCompanies", swiperOptions);
                            /* eslint-enable @typescript-eslint/no-unused-vars */
                        }
                    }
                });
            }
        },
    };
})();
